import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../../../theme';
import { FA_SELECTOR } from '../../../styles/variables';

export const useShipmentPackagePieceListStyles = createStyles(({ token }) => ({
  pieceListButton: {
    position: 'absolute',
    top: '50%',
    right: 24, // To be aligned with assets inventory icon
    marginTop: -9,
    fontSize: ThemeFont.FONT_SIZE_XXS,
    fontWeight: 500,
    textTransform: 'uppercase',
    color: ThemeColors.COLOR_GREY_BLUISH,
    marginRight: ThemeSpaces.SPACE_SM,

    [`> ${FA_SELECTOR}`]: {
      fontSize: token.fontSizeLG,
      color: token.colorPrimary,
    },
  },
  pieceList: {
    padding: `${ThemeSpaces.SPACE_NORM}px 0`,

    '.TwoLinesSeparator': {
      [`@media (max-width: ${token.screenMDMax}px)`]: {
        '&:first-child': {
          display: 'none',
        },
      },
    },
  },
  pieceListRow: {
    display: 'flex',
    alignItems: 'center',
    padding: ThemeSpaces.SPACE_NORM,

    '> .ant-row': {
      marginBottom: -ThemeSpaces.SPACE_NORM,

      '> .ant-col': {
        marginBottom: ThemeSpaces.SPACE_NORM,
      },
    },
    '.number-in-circle': {
      marginRight: ThemeSpaces.SPACE_NORM_20,
    },
  },
}));
